module.exports = __webpack_public_path__ + "static/img/Adult-Human-Torso-A01-X-Ray3.22c28171.jpg";